import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "config.js";
import OrcaXBgLogo from '../../../assets/img/OrcaXBgLogo.jpg'
// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  CloseButton
} from "react-bootstrap";
import { isTokenValid } from "components/PrivateRoute.js";

function Login() {
  const navigate = useNavigate();
  const [cardClasses, setCardClasses] = useState("card-hidden");

  // State for form inputs, errors, and loading state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // Redirect to dashboard if already authenticated with a valid token
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (isTokenValid(token)) {
      let destination = "/admin/dashboard";
      try { const user = JSON.parse(localStorage.getItem("user")); if (user?.sandbox === true || user?.pilot === true) destination = "/admin/conversations"; } catch (_) { /* Keep the standard destination. */ }
      navigate(destination, { replace: true });
    } else if (token) {
      // Clean up corrupted/expired token right here to stop infinite loops safely
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("authUser");
    }
  }, [navigate]);

  // Fade-in card effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setCardClasses("");
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent page reload
    setErrorMsg("");    // Clear any previous errors
    setIsLoggingIn(true); // Set loading state to true

    try {
      console.log("API_BASE_URL:", API_BASE_URL);
      // Make POST request to backend /auth/login
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        email,
        password,
      });

      if (response.data.success) {
        // Store token & user info
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        navigate(response.data.user?.sandbox === true || response.data.user?.pilot === true ? "/admin/conversations" : "/admin/dashboard");
      } else {
        setErrorMsg(response.data.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      if (error.response?.data?.isUnverified) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/auth/verify-email", { state: { email } });
        return;
      }
      setErrorMsg(error.response?.data?.message || "An error occurred while logging in.");
    }
    setIsLoggingIn(false); // Reset loading state
  };

  return (
    <div
      className=" section-image h-100"
      style={{ backgroundImage: `url(${OrcaXBgLogo})`, backgroundRepeat: 'no-repeat', backgroundPosition: "center", backgroundSize: 'contain' }}

    >
      <div style={{ backgroundColor: 'transparent' }} className="content d-flex align-items-center p-0 my-auto h-100" >
        <Container>
          <Col className="mx-auto" lg="6" md="8">
            <Form className="form border-0" onSubmit={handleLogin}>
              <Card className={"card-login rounded " + cardClasses} style={{ border: "none", boxShadow: 'none', background: 'transparent' }}>
                {/* Header */}
                <Card.Header style={{ background: 'transparent' }} className="text-center pt-4 pb-3">
                  <h3 style={{ fontWeight: '700', fontSize: '2.5rem' }} className="text-center mb-1">Welcome</h3>
                  <small className="text-muted fs-6 font-weight-bold mb-0">
                    Enter your credentials to sign in to your account
                  </small>
                </Card.Header>

                {/* Body */}
                <Card.Body>
                  {errorMsg && (
                    <div className="alert alert-danger" role="alert">
                      {errorMsg}
                    </div>
                  )}

                  {/* Email Field */}
                  <Form.Group className="mb-5">
                    <Form.Label style={{ fontWeight: '700', fontSize: ".9rem" }} className="text-dark text-capitalize">
                      Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="fs-6 py-2 "
                      style={{ borderRadius: "8px", border: '2px solid #dee2e6' }}
                    />
                  </Form.Group>

                  {/* Password Field */}
                  <Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Form.Label style={{ fontWeight: '700', fontSize: ".9rem" }} className="text-dark text-capitalize">
                        Password
                      </Form.Label>
                      <Link to="/auth/ForgotPassword" style={{ fontWeight: '700', fontSize: ".9rem", color: "#0090ff" }} className="small fw-bold">
                        Forgot password?
                      </Link>
                    </div>
                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="fs-6 py-2"
                      style={{ borderRadius: "8px", border: '2px solid #dee2e6' }}
                    />
                  </Form.Group>
                </Card.Body>

                {/* Footer */}
                <Card.Footer className="text-center">
                  <Button
                    type="submit"
                    className="w-100 btn-wd fw-bolder py-2 px-4 fs-6"
                    disabled={isLoggingIn}
                    style={{ borderRadius: "8px", backgroundColor: "#014c95" }}
                  >
                    {isLoggingIn ? "Signing in..." : "Sign in"}
                  </Button>
                  <p className="mt-3 mb-2 text-center text-muted" style={{ fontSize: "0.82rem", lineHeight: "1.4" }}>
                    By signing in, you agree to our{" "}
                    <Link to="/terms" target="_blank" className="text-decoration-underline" style={{ color: "#014c95", fontWeight: "600" }}>
                      Terms of Use
                    </Link>{" "}
                    and{" "}
                    <Link to="/privacy" target="_blank" className="text-decoration-underline" style={{ color: "#014c95", fontWeight: "600" }}>
                      Privacy Policy
                    </Link>.
                  </p>
                  <p className="mt-2 mb-0">
                    <small style={{ fontWeight: '700', fontSize: ".9rem" }}>
                      Need an account?{" "}
                      <Link to="/contact-us" className="fw-bold" style={{ fontWeight: '700', fontSize: ".9rem", color: "#0090ff" }}>
                        Contact Us
                      </Link>
                    </small>
                  </p>
                </Card.Footer>
              </Card>
            </Form>
          </Col>
        </Container>
      </div>
      <div
        className="full-page-background"
        style={{
          backgroundImage:
            "url(" + require("assets/img/full-screen-image-2.jpg") + ")"
        }}
      ></div>
    </div>
  );
}

export default Login;
